import ThingsManagerClass from "../../libs/base/ThingsManagerClass";
import LtikeCommon from "../common/LtikeCommon";
import ToolsModalClass from "./ToolsModalClass";
import Util from "../../libs/util/Util";
import dayjs from "dayjs";
import HotelDataClass from "./HotelDataClass";
import RippleManagerClass from "../common/RippleManagerClass";
import CalenderModalClass from "../common/CalenderModalClass";

/**
 * ホテルの検索枠
 */
export default class HotelSearchAreaClass extends ThingsManagerClass{
    static BLOCK_COUNT = 5;

    constructor(_parent){
        super();
        this.name = "HotelSearchAreaClass";

        this.parent = _parent;

        this.CL_LOADING = "isLoading";
        this.CL_DISABLE = "isDisable";
        this.CL_ACTIVE ="isActive";

        this.BLOCK_COUNT = HotelSearchAreaClass.BLOCK_COUNT;

        this.key = LtikeCommon.PREFIX+"_hotel_area";
        this.isPageMoveLoading = false;
    }

    onCreate() {
        this.target = $('[data-id="hotel_area"]',this.parent);
        this.target.css({display:"block"});

        this.things = {};

        this.things.calenderModal = new CalenderModalClass("calender_hotel",this.parent);
        this.things.calenderModal.on(this.things.calenderModal.EVENT_POSITIVE,(e,p)=>{
            this.changeCalender();
        });

        this.things.toolsModal = new ToolsModalClass(this.parent);
        this.things.toolsModal.on(this.things.toolsModal.EVENT_POSITIVE,(e,p)=>{
            this.onFilter();
        });
        this.things.toolsModal.on(this.things.toolsModal.EVENT_NEGATIVE,(e,p)=>{
            this.onFilter();
        });

        super.onCreate();

        this.loader = $(`.${this.key}__loader`,this.target);
        this.embed = $(`.${this.key}__list`,this.target);
        this.zero = $(`.${this.key}__zero`,this.target);
        this.errorMsg = $(`.${this.key}__error_msg`,this.target);

        this.pagenation = $(`.${this.key}__pagination`,this.target);
        this.pagenationUl = $(`.${this.key}__pagination ul`,this.target);
        this.pagenationBtnFirst = $(`[data-type="first"]`,this.pagenation);
        this.pagenationBtnLast = $(`[data-type="last"]`,this.pagenation);
        this.pagenationBtnFirst.on("click",this.onClick_PageFirst.bind(this));
        this.pagenationBtnLast.on("click",this.onClick_PageLast.bind(this));

        this.count = $(`.${this.key}__nav__count`,this.target);
        this.countTotal = "";
        this.countCurrent = "";

        this.sortLi = $(`.${this.key}__nav__sort li`,this.target)
        $(`a`,this.sortLi).on("click",this.onClick_sort.bind(this));

        this.hotelData = new HotelDataClass();
        this.hotelData.on(this.hotelData.EVENT_FIRST_CALL_END,this.firstApiCallBack.bind(this));
        this.hotelData.on(this.hotelData.EVENT_FILTER_CALL_END,this.filterApiCallBack.bind(this));
        this.hotelData.on(this.hotelData.EVENT_TOTAL_COUNT_CHANGE,()=>{
            $(`[data-type="total"]`,this.count).text(this.hotelData.total);
        });
        this.hotelData.on(this.hotelData.EVENT_DATA_ADD_LOAD,()=>{
            $("a",this.pagenationUl).filter("."+this.CL_LOADING).each((i,e)=>{
                const _this = $(e);
                if(this.hotelData.dataLoadStatus[parseInt(_this.attr("data-load_index"))]){
                    _this.removeClass(this.CL_LOADING);
                }
            });
            //console.log("EVENT_DATA_ADD_LOAD",this.hotelData.dataLoadStatus,this.isPageMoveLoading);

            if(this.isPageMoveLoading){
                const start = this.pageIndex * this.BLOCK_COUNT;
                const end = start + this.BLOCK_COUNT;
                const mustLoadIndexStart = Math.floor( start/ this.hotelData.ITEM_MAX_COUNT);
                const mustLoadIndexEnd = Math.floor(end / this.hotelData.ITEM_MAX_COUNT);

                //console.log(this.hotelData.dataLoadStatus[mustLoadIndexStart],this.hotelData.dataLoadStatus[mustLoadIndexEnd]);
                if(this.hotelData.dataLoadStatus[mustLoadIndexStart] && this.hotelData.dataLoadStatus[mustLoadIndexEnd]) {
                    this.pageMove(this.pageIndex);
                }
            }
        });
        this.hotelData.on(this.hotelData.EVENT_API_ERROR,this.apiCallBackError.bind(this));

        this.depTxt = $(`.${this.key}__date .-date`,this.target);
    }

    onChangeBreakPoint(b) {
        super.onChangeBreakPoint(b);

        //console.log("onChangeBreakPoint0",this.things.calenderModal,this.things.calenderModal.things.calender,Util.MASTER_AIRPLANE_TICKET);
        if(!this.things.calenderModal || !this.things.calenderModal.things.calender || !Util.MASTER_AIRPLANE_TICKET) return;
        //console.log("onChangeBreakPoint");
        this.things.calenderModal.onClose(this.EVENT_NEGATIVE);
        this.things.calenderModal.things.calender.isSlide = (!Util.isBreakpoint);
        this.onSetData();

    }

    onSetDefaultData(_json){
        //console.log("onSetDefaultData",_json);

        this.things.calenderModal.onSetData(Util.MASTER_AIRPLANE_TICKET.calender_term);

        this.json = _json;
        const going = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(7,"d");
        const back = going.add(1,"d");

        this.things.calenderModal.onSetDate({going:going,back:back});

        //this.depTxt.text(going.format('YYYY年MM月DD日出発'));

        this.firstApiCall(going,back);
    }

    changeCalender(){
        this.loader.show();

        this.hotelData.sortType = 0;
        this.sortLi.removeClass(this.CL_ACTIVE).eq(0).addClass(this.CL_ACTIVE);

        const data = this.things.calenderModal.getData();
        const going = dayjs(data.going);
        const back = dayjs(data.back);
        this.firstApiCall(going,back);
    }

    firstApiCall(going,back){

        let params = "";
        //チェックインを一週間後で設定

        const json = this.json;

        params += "checkindate="+going.format('YYYYMMDD');
        //チェックアウトをチェックインの次の日
        params += "&checkoutdate="+back.format('YYYYMMDD');

        params += '&roomnum='+json.rooms.length;
        json.rooms.forEach((r,i)=>{
            const n = i+1;
            params += `&adtnum${n}=${r.adult}`;
            params += `&chdnum${n}=${r.ageList.length}`;
            params += `&chdage${n}=${r.ageList.join(",")}`;
        });

        this.params = params;

        let addParams = '';
        addParams += 'regionid='+json.place.id;
        addParams += '&regionid_type='+json.place.type;

        //console.log(params);
        this.params = params;

        this.depTxt.text(`IN ${going.format('YYYY/MM/DD')} - OUT ${back.format('YYYY/MM/DD')}`);

        this.errorMsg.hide();
        this.hotelData.firstCall(addParams+"&"+params,this.firstApiCallBack.bind(this));
    }

    onSetData(){
        this.things.calenderModal.onSetData(Util.MASTER_AIRPLANE_TICKET.calender_term);
    }

    firstApiCallBack(e){
        //console.log("firstApiCallBack",this.hotelData.data);

        this.things.toolsModal.onSetDefaultData(this.hotelData.filter);

        this.pageIndex = -1;
        this.createHotelItem();
        this.pageMove(0);
    }

    apiCallBackError(e,res){
        console.error("apiCallBackError",res);
        this.embed.empty();
        this.count.hide();
        this.zero.hide();
        this.errorMsg.show();
        this.pagenation.hide();
        this.target.removeClass(this.CL_LOADING);
        this.loader.hide();
    }

    onClick_sort(e) {
        e.preventDefault();
        const _this = $(e.currentTarget);

        const sortType = _this.attr("data-v");
        if (sortType === this.hotelData.sortType) return;
        this.hotelData.sortType = sortType;

        const index = this.sortLi.index(_this.closest("li"));
        this.sortLi.removeClass(this.CL_ACTIVE).eq(index).addClass(this.CL_ACTIVE);

        this.onFilter();
    }

    onFilter(){
        this.loader.show();
        //console.log(params);
        //this.params = params;
        //catalogid=202310241805525555021721731202114880&accesskey=56343d401cec10d583476d05079c8256&pagenumber=1

        this.hotelData.tools = this.things.toolsModal.tools.target;
        this.hotelData.filterCall();
    }

    filterApiCallBack(){
        //console.log("filterApiCallBack");
        this.errorMsg.hide();
        this.pageIndex = -1;
        this.pageMove(0);
        this.createHotelItem();
    }

    createHotelItem(){
        //console.log("createHotelItem",this.hotelData.total);
        let isPagenation = true;
        if(this.hotelData.total > 0){
            if(this.hotelData.total <= this.BLOCK_COUNT){
                isPagenation = false;
            }

            this.zero.hide();
            this.count.show();
        } else {
            isPagenation = false;
            this.embed.empty();
            this.zero.show();
            this.count.hide();
        }

        if(isPagenation){
            this.pagenation.show();
        } else {
            this.pagenation.hide();
        }

        this.target.removeClass(this.CL_LOADING);
        this.loader.hide();
    }

    onClick_PageFirst(e){
        e.preventDefault();
        this.pageMove(0,true);
    }

    onClick_PageLast(e){
        e.preventDefault();
        let index = this.hotelData.lastIndex - 1;
        this.pageMove(index,true);
    }

    onClick_PageCount(e){
        e.preventDefault();
        const _this = $(e.currentTarget);
        const index = parseInt(_this.attr("data-n"));
        this.pageMove(index,true);
    }

    pageMove(_n,_isClick = false){
        if(_n === this.pageIndex && !this.isPageMoveLoading || this.hotelData.total < 1) return;

        if(_isClick) Util.runScroll(this.target);

        if(this.hotelItemRipple){
            this.hotelItemRipple.onRemove();
            this.hotelItemRipple = null;
        }

        const data = this.hotelData.get(_n);
        //console.log("pageMove --- :",_n,data,this.isPageMoveLoading);
        let html = '';
        if(data.length < 1){
            this.isPageMoveLoading = true;
            html = `<div class="${this.key}__list__loading"></div>`;
        } else {
            this.isPageMoveLoading = false;
            html = this.createHotelItemHtml(data);
        }
        this.embed.html(html);

        this.hotelItemRipple = new RippleManagerClass(this.embed);
        this.hotelItemRipple.onCreate();

        this.pageIndex = _n;

        this.changeCurrent();
        this.changePageNation();
    }

    changeCurrent(){
        let start,end;
        if(this.hotelData.total <= this.BLOCK_COUNT){
            start = 0;
            end = this.hotelData.total;
        } else {
            start = this.pageIndex * this.BLOCK_COUNT;
            end = Math.min(start + this.BLOCK_COUNT,this.hotelData.total);
        }
        $(`[data-type="current"]`,this.count).text(`${start + 1}〜${end}`);
    }

    changePageNation(){

        if(this.pageNationRipple){
            this.pageNationRipple.onRemove();
            this.pageNationRipple = null;
        }
        $("a",this.pagenationUl).off("click",this.onClick_PageCount.bind(this));

        const BUTTON_MAX = 5;
        const BUTTON_SPLIT = 2;
        let start = Math.max(0,this.pageIndex - BUTTON_SPLIT);
        const end = Math.min(start + BUTTON_MAX,this.hotelData.lastIndex);
        start = Math.max(0,Math.min(end - BUTTON_MAX,start));
        //console.log("changePageNation",this.pageIndex,start,end);

        let html = '';
        for(let i = start; i<end;i++){
            const startIndex = i * this.BLOCK_COUNT;
            const endIndex = startIndex + this.BLOCK_COUNT;
            const loadIndex = Math.floor(startIndex / this.hotelData.ITEM_MAX_COUNT);
            const loadIndexEnd = Math.floor(endIndex / this.hotelData.ITEM_MAX_COUNT);
            const isDataLoad = (this.hotelData.dataLoadStatus[loadIndex] && this.hotelData.dataLoadStatus[loadIndexEnd]);
            html += `<li><a href="" data-n="${i}" class="js-ripple ${(i===this.pageIndex)?"isActive":""} ${(!isDataLoad)?this.CL_LOADING:""}" data-load_index="${loadIndex}"><span>${i+1}</span></a></li>`;
        }
        this.pagenationUl.html(html);
        $("a",this.pagenationUl).on("click",this.onClick_PageCount.bind(this));

        if(this.pageIndex === 0){
            this.pagenationBtnFirst.addClass(this.CL_DISABLE);
        } else {
            this.pagenationBtnFirst.removeClass(this.CL_DISABLE);
        }

        if(this.pageIndex === this.hotelData.lastIndex - 1){
            this.pagenationBtnLast.addClass(this.CL_DISABLE);
        } else {
            this.pagenationBtnLast.removeClass(this.CL_DISABLE);
        }

        this.pageNationRipple = new RippleManagerClass(this.pagenationUl);
        this.pageNationRipple.onCreate();
    }

    createHotelItemHtml(items){
        let re = '';

        const hrefBase = 'https://tour.l-tike.com/hotels/domestic/hotel/';

        //console.log(items);

        items.forEach((item)=>{
            //console.log(item);
            const price = item.roomratedetailslist.roomratedetails.rateinfos.rateinfolist.rateinfo;
            const bonus = price.pontapointareaadd + price.pontapointhoteladd;

            const cp_code = item.campaigncode;
            let cpImgHtml = "",cpPriceHtml = "";

            const isPromo = price.chargeablerateinfo.promo;

            if(cp_code){
                const cp = this.hotelData.cp_data[cp_code];
                cpImgHtml += `<div class="${this.key}__item__img__cp" data-sale="${isPromo}">`;
                cpImgHtml += `<div><img src="${cp.campaign_icon_path}" alt="${cp.name}"></div>`;
                cpImgHtml += `</div>`;

                cpPriceHtml += `<div class="${this.key}__item__cp_price">`;
                cpPriceHtml += `<div class="-label"><img src="${cp.discount_icon_path}" alt=""></div>`;
                cpPriceHtml += `<div class="-price">`;
                cpPriceHtml += `<dl><dt>旅行代金</dt><dd>¥${Util.commaPunctuation(price.campaign.price)}</dd></dl>`;
                cpPriceHtml += `<dl><dt>${cp.discount_title}</dt><dd>¥${Util.commaPunctuation(price.campaign.discount)}</dd></dl>`;
                cpPriceHtml += `<dl><dt>お支払い金額</dt><dd>¥${Util.commaPunctuation(price.campaign.payment)}</dd></dl>`;
                cpPriceHtml += `</div>`;
                cpPriceHtml += `</div>`;

                //console.log(price,cp);
            }
            let saleImgHtml = '',salePriceHtml = '';

            if(isPromo === "true"){
                //console.log(item);

                const info = price.chargeablerateinfo;
                const discountPer = Math.floor(100-((parseInt(info.nightlyratetotal)+parseInt(info.surchargetotal))/(parseInt(info.strikethrough)+parseInt(info.surchargetotal))*100));
                const beforePrice = parseInt(info.strikethrough) + parseInt(info.surchargetotal);

                //console.log(discountPer,beforePrice);
                saleImgHtml = `<div class="${this.key}__item__sale_label"><div>SALE</div></div>`;

                salePriceHtml = `<div class="${this.key}__item__sale_price">`;
                salePriceHtml += `<span class="-price">￥${Util.commaPunctuation(beforePrice)}</span>${discountPer}<span class="-unit">%OFF</span>`;
                salePriceHtml += `</div>`;
            }

            //console.log(item.name,cp_code,price);
            //console.log(price);
            const href = `${hrefBase}${item.hotelid}?${this.params}`;
            re += `<div class="${this.key}__item">
                        ${saleImgHtml}
                        <a href="${href}" target="_blank" class="js-ripple">
                            <div class="${this.key}__item__img">
                                <img loading="lazy" alt="" src="${item.thumbnailurl}" class="-img">
                                ${cpImgHtml}
                            </div>
                            <div class="${this.key}__item__body">
                                <h3 class="${this.key}__item__ttl"><span>${item.name}</span></h3>
                                <div class="${this.key}__item__date">
                                    <div class="${this.key}__item__date__place">${item.shortdescription}</div>
                                    <div class="${this.key}__item__date__star" data-val="${item.hotelrating}"></div>
                                </div>
                                <div class="${this.key}__item__score">
                                    <div class="${this.key}__item__score__n">${item.review_agoda.rating_average}</div>
                                    <div class="${this.key}__item__score__detail">${item.review_agoda.rating_average_title}（${item.review_agoda.number_of_reviews}件のクチコミ）<br>ロケーション評価 : ${item.review_agoda.rating_location_average}</div>
                                </div>
                                <ul class="${this.key}__item__price">
                                    <li class="${this.key}__item__price__room">1部屋 x 1泊</li>
                                    <li class="${this.key}__item__price__n">${Util.commaPunctuation(price.chargeablerateinfo.total)}</li>
                                </ul>
                                <div class="${this.key}__item__point">${Util.commaPunctuation(price.pontapoint)}ポイント${bonus > 0 ? `＋${Util.commaPunctuation(bonus)}ボーナスポイント` : ''}</div>
                                ${cpPriceHtml}
                                ${salePriceHtml}
                            </div>
                        </a>
                    </div>`;
        });

        return re;
    }
}